import { observable, action, makeObservable, runInAction } from 'mobx';
import { getPersonFieldDataApi,getStudentProjectArchivesApi } from '@/api/project/archive';
import { RequestResult } from '@/api/requestType';
import message from '@/components/Toast';
import { cloneDeep } from 'lodash';
class ProjectArchive {
    constructor() {
        makeObservable(this);
    }
    @observable projectArchiveInfo = {};
    @action
    setProjectArchiveInfo = (v) => {
        this.projectArchiveInfo = Object.assign({}, this.projectArchiveInfo, v);
    };
    // 查询学习档案数据
    getProjectArchiveInfo = async (params) => {
        const res: RequestResult = await getStudentProjectArchivesApi(params);
        if (res.code === '00000') {
            runInAction(() => {
                this.setProjectArchiveInfo(res.data);
            });
        } else {
            return message.error(res.msg);
        }
    };
    @observable archiveFieldInfo = [];
    @action
    setArchiveFieldInfo = (v) => {
        this.archiveFieldInfo = v;
    };
    handleClassField = (data, valueMap) => {
        let temData = cloneDeep(data);
        temData.forEach((ele) => {
            if (ele.en_name === 'org_id') {
                //这个预置字段 需要单独处理下
                ele.field_type = 7;
            }
            //增加value字段--回显时使用
            if (valueMap) {
                ele.value = valueMap[ele.en_name];
            }
        });
        temData = temData.filter((ele) => ele.enabled === 0);
        return temData.sort((a, b) => a.sort - b.sort);
    };
    mapToOptions = (map, rename = { label: 'label', value: 'value' }) => {
        let res: any[] = [];
        map.forEach((value, key) => {
            res.push({
                [rename.label]: value,
                [rename.value]: key
            });
        });
        return res;
    };
    getClassItem = (data) => {
        if (!data) return [];
        const class_map = new Map([
            [1, '基本信息'],
            [2, '联系方式'],
            [4, '学习经历'],
            [3, '工作信息'],
            [5, '党员档案'],
            [6, '账号信息']
        ]);
        const keys = Object.keys(data).map((ele) => Number(ele)); //将后端返回的keys取出
        return this.mapToOptions(class_map).filter((ele) => keys.includes(ele.value));
    };
    handleClassesField = (data, valueMap = null) => {
        let temData = cloneDeep(data),
            classData: any[] = this.getClassItem(temData); //获取分类
        classData.forEach((ele: any) => {
            ele.children = this.handleClassField(temData[ele.value], valueMap);
        });
        classData = classData.filter((item: any) => item.children && item.children.length > 0);
        return classData;
    };
    // 查询学习档案个人字段数据
    getProjectFieldInfo = async (params) => {
        const res: RequestResult = await getPersonFieldDataApi(params);
        if (res.code === '00000') {
            runInAction(() => {
                let formatData = this.handleClassesField(res.data?.field_key, res.data?.field_value);
                console.log(formatData,'=========s======');
                this.setArchiveFieldInfo(formatData);
            });
        } else {
            return message.error(res.msg);
        }
    };
}
export default new ProjectArchive();